import {
  BodyText,
  Drawer,
  DrawerBody,
  DrawerHeader,
  Heading,
} from '@postscript/components';
import moment from 'moment';
import React, { useRef } from 'react';
import styled from 'styled-components';

interface SenderMessageDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  subscriber?: any;
}

const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
`;

const CardSection = styled.div`
  border: 1px solid var(--border-color-dim);
  border-radius: var(--border-radius-small);
  padding: var(--spacing-4) var(--spacing-4);
  background: var(--background-primary, #fff);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
`;

const SectionTitle = styled(Heading).attrs({
  variant: 'small',
  as: 'h3',
  size: 'small',
})`
  margin-bottom: var(--spacing-1);
  font-weight: bold;
`;

const SenderMessageDrawer: React.FC<SenderMessageDrawerProps> = ({
  isOpen,
  onClose,
  subscriber,
}) => {
  const headerRef = useRef<HTMLElement>(null);

  return (
    <Drawer
      isOpen={isOpen}
      onCancel={onClose}
      dismissOnBackdropClick
      firstFocusableElement={headerRef}
    >
      <DrawerHeader
        onCancel={onClose}
        description="This message was created from the following information."
        ref={headerRef}
        data-testid="sender-message-drawer-header"
      >
        Message Details
      </DrawerHeader>
      <DrawerBody>
        <DrawerContent>
          <CardSection>
            <SectionTitle>Message</SectionTitle>
            <BodyText size="small">
              Message data is not available yet. Check back later.
            </BodyText>
          </CardSection>
          <CardSection>
            <SectionTitle>Subscriber</SectionTitle>
            <BodyText size="small">
              {subscriber?.subscriber?.created_at
                ? `Subscriber opted in on ${moment(
                    subscriber.subscriber.created_at,
                  ).format('MM/DD/YY, hh:mm:ss A')} CT`
                : 'Subscriber data is not available yet. Check back later.'}
            </BodyText>
          </CardSection>
          <CardSection>
            <SectionTitle>Knowledge Bases</SectionTitle>
            <BodyText size="small">
              Knowledge base data is not available yet. Check back later.
            </BodyText>
          </CardSection>
        </DrawerContent>
      </DrawerBody>
    </Drawer>
  );
};

export default SenderMessageDrawer;
